import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { VbBtnPrimaryDirective } from 'rev-shared/ui/buttons/VbBtnPrimary.Directive';
import { VbTextAreaModule } from 'rev-shared/ui/textArea/VbTextArea.Module';
import { VbUiBtnDangerDirective } from 'rev-shared/ui/buttons/VbUiBtnDanger.Directive';
import { VbUiRadioBtnDirective } from 'rev-shared/ui/buttons/VbUiRadioBtnAngular.Directive';
import { VbUiRadioBtnGroupDirective } from 'rev-shared/ui/buttons/VbUiRadioBtnGroupAngular.Directive';
import { WebexTeamsModule } from 'rev-portal/scheduledEvents/webex-teams/WebexTeams.Module';
import { ZoomAngularModule } from 'rev-portal/scheduledEvents/zoom/ZoomAngularModule';

import { CollapseModule } from 'ngx-bootstrap/collapse';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { RecordingProcessComponent } from './RecordingProcess.Component';
import { StatusSpinnersAngularModule } from 'rev-shared/statusSpinners/StatusSpinnersAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { VbUiTooltipComponent } from 'rev-shared/ui/tooltip/VbUiTooltip.Component';

import { RecordingMenuComponent } from './RecordingMenu.Component';
import { RecordingTimerComponent } from './RecordingTimer.Component';

const components = [
	RecordingMenuComponent,
	RecordingTimerComponent,
	RecordingProcessComponent,
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CollapseModule,
		CommonModule,
		DateAngularModule,
		DirectivesAngularModule,
		FormDirectivesAngularModule,
		FormGroupAngularModule,
		FormsModule,
		ReactiveFormsModule,
		SpinnerAngularModule,
		StatusSpinnersAngularModule,
		TranslateModule,
		TypeaheadModule,
		ValidationAngularModule,
		ValidationModule,
		VbBtnPrimaryDirective,
		VbTextAreaModule,
		VbUiBtnDangerDirective,
		VbUiRadioBtnDirective,
		VbUiRadioBtnGroupDirective,
		VbUiTooltipComponent,
		WebexTeamsModule,
		ZoomAngularModule
	]
})
export class RecordingAngularModule {}
